import React from 'react';
import { MAIN_WIDTH } from '@link/share/constants';
import { appendWidth, getResponsiveImgProps } from '@link/share/utils';

type ImgProps = React.ComponentProps<'img'>;

const isRemoteUrl = (src: string) => /^https?:\/\//.test(src);

const Img: React.FC<ImgProps> = ({ src, sizes, ...rest }) => {
  let compressed = src;
  let responsiveProps = {};

  if (src && isRemoteUrl(src)) {
    compressed = appendWidth(src, MAIN_WIDTH);
    responsiveProps = getResponsiveImgProps(src, sizes ?? `${MAIN_WIDTH}px`);
  }
  return <img src={compressed} {...responsiveProps} {...rest} />;
};

export default Img;
